import axios from 'axios';
import requireAuth from './interceptors/auth';
import api from '@/plugins/kitsu';
import requireOperatingCompany from './interceptors/operatingCompany';

const user = api('current_user_service', {
  middleware: [requireAuth],
});

const currentUser = api('current_user_service', {
  middleware: [requireAuth, requireOperatingCompany],
});

const devise = axios.create({
  baseURL: `${process.env.VUE_APP_API_URL}/current_user_service/public`,
  timeout: 15000,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json;charset=UTF-8',
  },
});

export default Object.freeze({
  login: payload => devise.post('auth/sign_in', payload), // headers must always be added to localStorage, maybe use with store?
  logout: () => user.delete('public/auth', 'sign_out'),
  resetPassword: email => devise.post('auth/password', email),
  changePassword: payload => devise.put('auth/password', payload),
  rememberLogin: () => user.axios.put('extend_token_expiry', {}),
  getCurrentUser: (params = {}) =>
    user.get('current-user', {
      include: 'image,operatingCompany',
      ...params,
    }),
  patchCurrentUser: formData =>
    user.axios.request({
      url: 'current-user',
      method: 'patch',
      data: { data: { type: 'current-users', attributes: formData } },
      headers: {
        'Content-Type': 'application/vnd.api+json',
      },
    }),
  // Current user
  getCurrentUserDashboardTiles: (params = {}) =>
    currentUser.get('dashboard-tiles', {
      ...params,
    }),
  getCurrentUserDashboardTile: (id, params = {}) =>
    currentUser.get(`dashboard-tiles/${id}`, {
      ...params,
    }),
  createImport: formData => currentUser.post('imports', formData),
  getImportUniqueColumns: (params = {}) =>
  currentUser.get('import_unique_columns', {
    ...params,
  }),

  // Custom Fields
  getCustomFields: (params = {}) =>
    currentUser.get(`custom-fields`, {
      page: {limit: 100},
      ...params,
    }),

  // Created phases
  getCreatedPhaseDetails: (params = {}) =>
    currentUser.get(`created_phase_details`, {
      ...params,
  }),

  // Approval requests
  getApprovalRequestDetails: (params = {}) =>
    currentUser.get(`approval_request_details`, {
      ...params,
  }),

  // Export options
  getExportOptions: (params = {}) => 
    currentUser.get(`export-options`, {
      ...params,
  }),

  // Applied approval condition profiles
  patchAppliedApprovalConditionProfile: (id, formData) =>
    currentUser.patch('applied-approval-condition-profiles', { id, ...formData }),
});
